import QRCode from 'qrcode';

import appError from '#shared/util/appError.js';

/**
 * Generate QR code
 * @param {object} canvas
 * @param {string} qrCodeLink - QR Code link to the Payconiq app
 */
const qrCodePayconiq = (canvas, qrCodeLink = '') => {
	const qrCodeOptions = {
		margin: 2,
		width: 180,
		color: {
			dark: '#7B314A', // Needs to be "magenta" based on Payconiq styleguide
			light: '#FFF'
		}
	};
	// Generate QR code
	QRCode.toCanvas(canvas, qrCodeLink, qrCodeOptions, (error) => {
		if (error) {
			throw appError(error, {
				code: 'APP_FRONTEND_UTIL',
				origin: 'qrCodePayconiq',
				description: 'Could not generate QR code - Payconiq'
			});
		}
	});
};

export default qrCodePayconiq;
